<template>
  <div style="height: 40px;">
    <v-text-field
      @input="setModelData"
      @keydown.enter="eventEnter"
      :label="label"
      single-line
      outlined
      dense
      :value="model"
      :type="inputType"
      full-width
      style="border-radius: 20px;"
      :disabled="disable"
      background-color="#ffffff"
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    label: "",
    model: "",
    inputType: "",
    autofocus: Boolean,
    disable : {
      type : Boolean,
      default : false,
    }
  },
  name: "Input-text-field",
  methods: {
    setModelData(val) {
      this.$emit("update", val);
    },
    eventEnter() {
      this.$emit('onEnter');
    }
  }
};
</script>

<style scoped></style>
